import { Reducer } from 'redux';
import { ConsultaAgendamentosState, ConsultaAgendamentosTypes } from './types';

const INITIAL_STATE: ConsultaAgendamentosState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  total: {
    total: 0,
    totAgendado: 0,
    totExpedido: 0,
    totEntrega: 0,
    totColeta: 0,
    tAgeEntrega: 0,
    tAgeColeta: 0,
    tExpColeta: 0,
    tExpEntrega: 0,
    totFerro: 0,
    totMadeira: 0,
    qtdPlat: 0,
  },
};

const reducer: Reducer<ConsultaAgendamentosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ConsultaAgendamentosTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ConsultaAgendamentosTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case ConsultaAgendamentosTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case ConsultaAgendamentosTypes.FILTER_AGEMDAMEMTOS:
      return {
        ...state,
        filter: action.payload.filter,
      };
    default:
      return state;
  }
};

export default reducer;
